import { Route, Routes } from "react-router-dom";

import { HttpClientInterceptorProvider } from "@hd/http-client/HttpClientInterceptorProvider";
import HubProvider from "@hd/hub/HubProvider";

import { PrivateRoute } from "./core/auth/PrivateRoute";
import LayoutPage from "./core/layout/Layout";
import LegacyHdBridgePage from "./core/legacy-hd-bridge/LegacyHdBridgePage";
import useConciergeRoutes from "./features/concierge/useConciergeRoutes";
import useDooryRoutes from "./features/doory/useDooryRoutes";
import useLoginRoutes from "./features/login/useLoginRoutes";
import usePersonsRoutes from "./features/persons/usePersonsRoutes";

function AppRoutes() {
  const LoginRoutes = useLoginRoutes();
  const PersonsRoutes = usePersonsRoutes();
  const ConciergeRoutes = useConciergeRoutes();
  const DooryRoutes = useDooryRoutes();
  return (
    <HttpClientInterceptorProvider>
      <Routes>
        {LoginRoutes}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <HubProvider>
                <LayoutPage />
              </HubProvider>
            </PrivateRoute>
          }
        >
          {PersonsRoutes}
          {ConciergeRoutes}
          {DooryRoutes}
          <Route path="/" element={<LegacyHdBridgePage />} />
          <Route path="*" element={<LegacyHdBridgePage />} />
        </Route>
      </Routes>
    </HttpClientInterceptorProvider>
  );
}

export default AppRoutes;
